module.exports = __webpack_public_path__ + "img/PG.bc289be2.png";